<template>
  <egg-description
    title="aboutus.ourFacilities"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconDeepBlue', imgFormat: 'svg' }"
    :eggImgObj="{ componentName: 'aboutus', imgName: 'ourFacilities', imgFormat: 'svg', position: 'right' }"
    :isShowStarBackgroundRight="false"
    :starBackgroundLeftObj="{ componentName: 'shared', imgName: 'starGroupIconBrownLeft', imgFormat: 'svg', bottom: '-10%' }"
    textMode="text"
    description="aboutus.ourFacilitiesDesc"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useAboutUsStore } from "@/stores/aboutus";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const aboutusStore = useAboutUsStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>